import Neto_cambio from "./Neto_cambio.png";
import NetNeto_felizo from "./Neto_feliz.png";
import Neto_tranquilo from "./Neto_tranquilo.png";
import Yolanda_dinero from "./Yolanda_dinero.png";
import Yolanda_reciboLuz from "./Yolanda_reciboLuz.png";
import Yolanda_tranquila from "./Yolanda_tranquila.png";

import Anahi_feliz from "./Anahi_feliz.png";
import Anahi_ticket from "./Anahi_ticket.png";
import Yonny_saludo from "./Yonny_saludo.png";
import Yonny_tranqui from "./Yonny_tranqui.png";
import Yonny_tarjeta from "./Yonny_tarjeta.png";

import QuestionCard1 from "./QuestionCard1.png";
import QuestionCard2 from "./QuestionCard2.png";
import QuestionCard3 from "./QuestionCard3.png";
import QuestionCard4 from "./QuestionCard4.png";
import QuestionCard5 from "./QuestionCard5.png";
import QuestionCard6 from "./QuestionCard6.png";
import QuestionCard7 from "./QuestionCard7.png";

import Ticket from "./Ticket.png";

import miniMonitor1 from "./miniMonitor1.png";
import miniMonitor2 from "./miniMonitor2.png";

import WhiteCard1 from "./WhiteCard1.png";
import WhiteCard2 from "./WhiteCard2.png";
import WhiteCard3 from "./WhiteCard3.png";
import WhiteCard4 from "./WhiteCard4.png";

export const imgTema6 = {
	Neto_cambio,
	NetNeto_felizo,
	Neto_tranquilo,
	Yolanda_dinero,
	Yolanda_reciboLuz,
	Yolanda_tranquila,
	Anahi_feliz,
	Anahi_ticket,
	Yonny_saludo,
	Yonny_tranqui,
	Yonny_tarjeta,
	Ticket,
	QuestionCard1,
	QuestionCard2,
	QuestionCard3,
	QuestionCard4,
	QuestionCard5,
	QuestionCard6,
	QuestionCard7,
	miniMonitor1,
	miniMonitor2,
	WhiteCard1,
	WhiteCard2,
	WhiteCard3,
	WhiteCard4,
}